import { IPreloaderAction, IPreloader } from 'models/preloader';

/** Action Types */
export const SHOW: string = 'preloader/SHOW';

/** Counter: Initial State */
const initialState: IPreloader = {
	isVisible: true,
};

/** Reducer: CounterReducer */
export function preloaderReducer(state = initialState, action?: IPreloaderAction) {
	switch (action.type) {
		case SHOW:
			return {
				isVisible: action.payload.isVisible,
			};

		default:
			return state;
	}
}

/** Action Creator: Decrements the Counter */
export function showPreloader(isVisible: boolean): IPreloaderAction {
	return {
		type: SHOW,
		payload: {
			isVisible,
		},
	};
}
